import axios from "axios"
import { urls } from "utils-lib/builds"
import {
  SUBMIT_CALL_BACK_REQUEST_PENDING,
  SUBMIT_CALL_BACK_REQUEST_FULFILLED,
  SUBMIT_CALL_BACK_REQUEST_FAILED,
} from "constants-lib/actionTypes"

const pendingAC = () => ({
  type: SUBMIT_CALL_BACK_REQUEST_PENDING,
})
const failedAC = () => ({
  type: SUBMIT_CALL_BACK_REQUEST_FAILED,
})
const fulfilledAC = (data) => ({
  type: SUBMIT_CALL_BACK_REQUEST_FULFILLED,
  payload: data,
})

// TODO: Finalize changes one API is delivered
export const submitCallbackRequest = (data) => (dispatch) => {
  dispatch(pendingAC())

  const api = `SUBMIT_CALL_BACK_REQUEST`

  const url = urls.url[api]

  const config = {
    headers: {
      "Request-Tracking-Id": "expcallbacktest1",
    },
  }

  return axios
    .create(config)
    .post(url, data)
    .then((response) => {
      dispatch(fulfilledAC(response.data))
      return { data: response.data, statusCode: response.status }
    })
    .catch((e) => {
      dispatch(failedAC())
      return e
    })
}
